import type { Template } from "@/types";

export const SQ_05_H1_V4: Template[] = [
    {
        id: "sq-05-h1v4-01",
        name: "SQ 01 - H1V4",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h1_v4_01.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 43, y: 149, width: 631, height: 418, rotation: 0, imageRotation: 0 },
            { id: "2", x: 868, y: 51, width: 204, height: 304, rotation: 0, imageRotation: 0 },
            { id: "3", x: 868, y: 363, width: 204, height: 303, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1080, y: 51, width: 204, height: 304, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1080, y: 363, width: 204, height: 303, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h1v4-02",
        name: "SQ 02 - H1V4",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h1_v4_02.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 43, y: 149, width: 631, height: 418, rotation: 0, imageRotation: 0 },
            { id: "2", x: 819, y: 75, width: 380, height: 567, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1207, y: 75, width: 125, height: 184, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1207, y: 267, width: 125, height: 184, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1207, y: 459, width: 125, height: 183, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h1v4-03",
        name: "SQ 03 - H1V4",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h1_v4_03.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 71, y: 75, width: 299, height: 567, rotation: 0, imageRotation: 0 },
            { id: "2", x: 378, y: 75, width: 266, height: 168, rotation: 0, imageRotation: 0 },
            { id: "3", x: 378, y: 250, width: 266, height: 392, rotation: 0, imageRotation: 0 },
            { id: "4", x: 785, y: 141, width: 287, height: 435, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1080, y: 141, width: 286, height: 435, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h1v4-04",
        name: "SQ 04 - H1V4",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h1_v4_04.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 69, y: 38, width: 575, height: 353, rotation: 0, imageRotation: 0 },    
            { id: "2", x: 69, y: 399, width: 187, height: 277, rotation: 0, imageRotation: 0 },
            { id: "3", x: 264, y: 399, width: 186, height: 277, rotation: 0, imageRotation: 0 },
            { id: "4", x: 458, y: 399, width: 186, height: 277, rotation: 0, imageRotation: 0 },
            { id: "5", x: 887, y: 75, width: 377, height: 566, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h1v4-05",
        name: "SQ 05 - H1V4",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h1_v4_05.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 134, width: 677, height: 449, rotation: 0, imageRotation: 0 },
            { id: "2", x: 685, y: 134, width: 301, height: 449, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1148, y: 134, width: 288, height: 450, rotation: 0, imageRotation: 0 },
            { id: "4", x: 993, y: 133, width: 147, height: 222, rotation: 0, imageRotation: 0 },
            { id: "5", x: 993, y: 363, width: 147, height: 222, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h1v4-06",
        name: "SQ 06 - H1V4",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h1_v4_06.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 44, y: 49, width: 926, height: 619, rotation: 0, imageRotation: 0 },
            { id: "2", x: 978, y: 49, width: 202, height: 306, rotation: 0, imageRotation: 0 },
            { id: "3", x: 978, y: 363, width: 202, height: 305, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1188, y: 49, width: 202, height: 306, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1188, y: 363, width: 202, height: 305, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h1v4-07",
        name: "SQ 07 - H1V4",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h1_v4_07.png",
        size: [1434, 717],
        style: {},
        slots: [        
            { id: "2", x: 45, y: 49, width: 202, height: 306, rotation: 0, imageRotation: 0 },
            { id: "3", x: 255, y: 49, width: 201, height: 306, rotation: 0, imageRotation: 0 },
            { id: "4", x: 45, y: 363, width: 202, height: 305, rotation: 0, imageRotation: 0 },
            { id: "5", x: 255, y: 363, width: 201, height: 305, rotation: 0, imageRotation: 0 },
            { id: "1", x: 463, y: 49, width: 927, height: 619, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h1v4-08",
        name: "SQ 08 - H1V4",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h1_v4_08.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 133, width: 680, height: 451, rotation: 0, imageRotation: 0 },          
            { id: "2", x: 687, y: 133, width: 300, height: 451, rotation: 0, imageRotation: 0 },
            { id: "3", x: 995, y: 133, width: 299, height: 451, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1301, y: 133, width: 133, height: 222, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1301, y: 362, width: 133, height: 222, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-05-h1v4-09",
        name: "SQ 09 - H1V4",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h1_v4_09.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 186, y: 114, width: 728, height: 489, rotation: 0, imageRotation: 0 },
            { id: "2", x: 922, y: 115, width: 160, height: 240, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1090, y: 115, width: 160, height: 240, rotation: 0, imageRotation: 0 },
            { id: "4", x: 922, y: 363, width: 160, height: 240, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1090, y: 363, width: 160, height: 240, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h1v4-10",
        name: "SQ 10 - H1V4",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h1_v4_10.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "2", x: 166, y: 75, width: 385, height: 567, rotation: 0, imageRotation: 0 },   
            { id: "3", x: 791, y: 75, width: 185, height: 254, rotation: 0, imageRotation: 0 },
            { id: "4", x: 984, y: 75, width: 184, height: 254, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1176, y: 75, width: 184, height: 254, rotation: 0, imageRotation: 0 },
            { id: "1", x: 791, y: 336, width: 569, height: 306, rotation: 0, imageRotation: 0 }
        ],
    },

];

